module.exports = __webpack_public_path__ + "img/igloo.fb2dfa8a.svg";